<script>
export default {
  name: 'CampaignLogChartGroupByHour',
  props: {
    campaignId: {
      type: [Number, String],
      default: null,
    },
    title: {
      type: String,
      default: ' نمودار کمپین بر اساس ساعات روز',
    },
  },
  data() {
    return {
      series: [
        {
          name: 'شروع نمایش',
          data: [],
        },
        {
          name: 'پایان نمایش',
          data: [],
        },
        {
          name: 'کلیک',
          data: [],
        },
        {
          name: 'نصب',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 2000,
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000,
            },
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          x: 500,
          labels: {
            rotate: -90,
          },
          categories: [],
        },
        dataLabels: {
          position: 'center',
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        colors: [
          '#f63e3e',
          '#eeb902',
          '#1cbb8c',
          '#5664d2',
          '#03d3fc',
          '#fc6f03',
          '#b2c8d9',
          '#c969be',
          '#03ffc4',
        ],
      },
    }
  },
  mounted() {
    this.fetchChartData()
  },
  methods: {
    fetchChartData() {
      let route = `campaigns/logs/chart/group-by-hour`
      if (this.campaignId) {
        route = `campaigns/${this.campaignId}/logs/chart/group-by-hour`
      }
      this.$axios.get(route).then((res) => {
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            xaxis: {
              categories: res.data.labels,
            },
          },
        }
        this.series[0].data = res.data.data.startShow
        this.series[1].data = res.data.data.endShow
        this.series[2].data = res.data.data.click
        this.series[3].data = res.data.data.install
        this.$refs.realtimeChart.updateSeries(this.series, false, true)
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="card ">
      <div class="card-body">
        <h5>{{ title }}</h5>
        <div>
          <div class="apex-charts" dir="rtl"></div>
          <apexchart
            :series="series"
            class="apex-charts"
            dir="rtl"
            ref="realtimeChart"
            :options="chartOptions"
            type="bar"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>
